<template>
  <div>
    <!-- <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="21">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/drainage/formActivity' }"
              >表单活动</el-breadcrumb-item
            >
            <el-breadcrumb-item>新建或编辑表单活动</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>

      <el-col :span="1"
        ><div class="grid-content">
          <el-button type="primary" class="mb10" @click="submitForm('ruleForm')">保存</el-button>
        </div></el-col
      >
    </el-row> -->
    <Step :step-index="stepIndex" />
    <div class="f-table-block" />
    <div class="f-table-block">
      <el-form
ref="ruleForm"
:model="ruleForm"
:rules="rules"
>
        <el-form-item
label="活动标题"
prop="activity_name"
>
          <el-input
            v-model="ruleForm.activity_name"
            placeholder="请输入活动标题"
            maxlength="50"
            show-word-limit
            class="w45"
          />
        </el-form-item>
        <el-row />

        <!-- <el-form-item label="活动时间" prop="long_term">
          <el-radio-group v-model="ruleForm.long_term">
            <el-radio :label="false">自定义时间</el-radio>
            <el-radio :label="true">长期有效</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item
label="活动时间"
prop="begin_time"
>
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="changeDate"
          />
          <span class="tips">不选则为长期有效</span>
        </el-form-item>
        <el-form-item
label="活动封面："
prop="image_cover"
>
          <div class="image-cover">
            <SpOnlyPicSelect
:image-url="ruleForm.image_cover"
@selectImage="selectImageData"
/>
          </div>
          <span class="tips">仅支持.jpg、.png、.gif文件</span>
          <span class="tips">文件大小不可超过2M</span>
        </el-form-item>
        <el-form-item
label="设置表单"
prop="template_id"
required
>
          <el-button
type="primary"
icon="el-icon-s-tools"
@click="handleSelectForm"
>
            选择表单
          </el-button>
          <div
v-if="selectFormData[1].selectName"
class="tips"
>
            表单: {{ selectFormData[1].selectName }}
          </div>
          <div
v-if="selectFormData[1].text"
class="tips"
>
            {{ selectFormData[1].text }}
          </div>
        </el-form-item>

        <!-- <el-form-item label="活动参与总数限制" prop="limitRadio" required>
          <el-radio-group v-model="ruleForm.limitRadio">
            <el-radio label="0">不限制</el-radio>
            <el-radio label="1">自定义</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item
label="活动名额"
prop="join_limit"
>
          <el-input
            v-model.number="ruleForm.join_limit"
            type="number"
            autocomplete="off"
            placeholder="请输入>0的整数"
            class="w45"
          />
          <span class="tips">不填写则为不限制</span>
        </el-form-item>

        <el-form-item
label="短信通知"
prop="sms_notice"
>
          <el-switch v-model="ruleForm.sms_notice" />
          <el-button
type="text"
class="ml20"
@click="handleText"
>
设置短信内容
</el-button>
        </el-form-item>
        <el-form-item v-if="ruleForm.text">
          <span class="tips">{{ ruleForm.text }}</span>
        </el-form-item>

        <el-form-item
label="活动说明"
prop="activity_desc"
>
          <el-input
            v-model="ruleForm.activity_desc"
            type="textarea"
            placeholder="请输入活动说明"
            class="w45"
          />
        </el-form-item>

        <el-form-item
label="分享文案"
prop="share_text"
>
          <el-input
            v-model="ruleForm.share_text"
            type="textarea"
            placeholder="请输入分享文案"
            class="w45"
          />
          <span class="tips">用于导购分享时的宣传文案</span>
        </el-form-item>

        <el-form-item
label="设置奖品"
prop="item_list"
>
          <el-button
type="primary"
icon="el-icon-s-tools"
@click="handleSelectGift"
>
            选择奖品
          </el-button>
        </el-form-item>

        <!-- <el-form-item label="设置奖品：">
          <MeterGoodsManager :meters="subTaskForm" />
        </el-form-item> -->
        <span
v-if="ruleForm.item_list && ruleForm.item_list[0]"
class="tips"
>奖品: {{ ruleForm.item_list[0].item_name }}</span>

        <!-- <el-form-item> -->
        <!-- <el-table :data="ruleForm.item_list" style="width: 100%">
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  @click="handleEditGift(scope.row)"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDeleteGift(scope.$index)"
                  circle
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column label="奖品图片" width="600">
              <template slot-scope="scope">
                <div class="imageUrl">
                  <el-image style="width: 100px; height: 100px" :src="scope.row.imageUrl" />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="item_name" label="奖品名称"> </el-table-column>
          </el-table> -->
        <!-- </el-form-item> -->

        <el-form-item
label="参与组织"
prop="store_filter"
>
          <el-radio-group v-model="ruleForm.store_filter">
            <el-radio label="include">
使用组织
</el-radio>

            <el-radio label="exclude">
排除组织
</el-radio>
          </el-radio-group>
          <div class="set">
            <div>
              <el-button
                v-if="ruleForm.store_filter === 'include'"
                type="primary"
                icon="el-icon-s-tools"
                @click="storeVisibleChange('include')"
              >
                设置组织
              </el-button>
            </div>
            <div>
              <el-button
                v-if="ruleForm.store_filter === 'exclude'"
                type="primary"
                icon="el-icon-s-tools"
                @click="storeVisibleChange('exclude')"
              >
                设置排除组织
              </el-button>
            </div>
            <span
              v-if="
                ruleForm.store_filter === 'include' &&
                includeShopList.length > 0 &&
                showTips === 'store'
              "
              class="tips"
              >已设置{{ includeShopList.length }}家门店</span>
            <span
              v-if="
                ruleForm.store_filter === 'include' &&
                includeShopList.length > 0 &&
                showGroup &&
                showTips === 'group'
              "
              class="tips"
              >已设置{{ includeShopList.length }}个群组</span>
            <span
              v-if="
                ruleForm.store_filter === 'exclude' &&
                excludeShopList.length > 0 &&
                showStore &&
                showTips === 'store'
              "
              class="tips"
              >已排除{{ excludeShopList.length }}家门店</span>
            <span
              v-if="
                ruleForm.store_filter === 'exclude' &&
                excludeShopList.length > 0 &&
                showGroup &&
                showTips === 'group'
              "
              class="tips"
              >已排除{{ excludeShopList.length }}个群组</span>
          </div>
        </el-form-item>

        <!-- <el-form-item v-if="ruleForm.store_filter === 'include'">
          <el-table :data="includeShopList" style="width: 100%">
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDeleteIncludeShop(scope.$index)"
                  circle
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="store_id" label="店铺id"> </el-table-column>
            <el-table-column prop="store_bn" label="店铺号"> </el-table-column>
            <el-table-column prop="store_name" label="店铺名称"> </el-table-column>
          </el-table>
        </el-form-item> -->

        <!-- <el-form-item v-if="ruleForm.store_filter === 'exclude'">
          <el-table :data="excludeShopList" style="width: 100%">
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDeleteExcludeShop(scope.$index)"
                  circle
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="store_id" label="店铺id"> </el-table-column>
            <el-table-column prop="store_bn" label="店铺号"> </el-table-column>
            <el-table-column prop="store_name" label="店铺名称"> </el-table-column>
          </el-table>
        </el-form-item> -->
      </el-form>
    </div>
    <!-- 选择表单 -->
    <SelectForm
      :select-form-visible="selectFormVisible"
      :select-form-data="selectFormData"
      @selectFormVisibleChange="selectFormVisibleChange"
    />

    <!-- 设置奖品 -->
    <SelectGift
      :select-gift-visible="selectGiftVisible"
      :select-gift-data="selectGiftData"
      @selectGiftVisibleChange="selectGiftVisibleChange"
    />

    <!-- 编辑门店 -->
    <!-- <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    /> -->

    <!-- 编辑不适用门店 -->
    <!-- <SpStoreSelect
      v-model="banStoreVisible"
      :select-data="selectBanStoreData"
      @chooseStore="chooseBanStore"
    /> -->

    <!-- 选择图片 -->
    <SpImageSelect
      :image-visible="showImgPicker"
      :choose-one="true"
      @closeImageDialog="onClosePicker"
      @chooseImage="onChangePicker"
    />

    <!-- 变更销售组织 -->
    <SpSalesOrganization
      v-model="salesOrganizationVisible"
      :show-store="showStore"
      :show-group="showGroup"
      :select-data="salesData"
      @saveBindOrganization="saveBindOrganization"
    />
    <!-- 设置短信内容 -->
    <SetText
      :set-text-visible="setTextVisible"
      :set-text-data="setTextData"
      @setTextVisibleChange="setTextVisibleChange"
    />
    <div class="fotter-toolbar">
      <el-button
class="mb10"
@click="back"
>
取消
</el-button>
      <el-button
type="plain"
class="mb10"
@click="submitForm('ruleForm', 0)"
>
        下一步，配置活动模板
      </el-button>
      <el-button
type="primary"
class="mb10"
@click="submitForm('ruleForm', 1)"
>
        不配置，立即保存
      </el-button>
    </div>
  </div>
</template>

<script>
import SelectForm from '@/components/formActivity/selectForm'
import SelectGift from '@/components/formActivity/selectGift'
import SetText from '@/components/formActivity/setText'

import Step from './step'

// import MeterGoodsManager from '@/components/meterGoodsManager'
import moment from 'moment'

export default {
  components: {
    SelectForm,
    // MeterGoodsManager,
    SelectGift,
    Step,
    SetText
  },
  data () {
    return {
      ruleForm: {
        activity_id: null,
        template_id: null,
        activity_name: '',
        date: null,
        image_cover: '',
        form: { text: '' },
        join_limit: '',
        limitRadio: '0', // 0 不限制
        sms_notice: false,
        activity_desc: '',
        store_filter: 'include', // all-全部店铺;include-指定;exclude-不适用
        gift: [],
        shopList: [],
        shopBanList: [],
        long_term: false,
        item_list: [],
        text: '您已经成功报名"{{活动名称}}"，您可凭此短信收到的链接到就近参与活动的门店核销领取奖品，详情点击{{活动链接}}。'
      },
      rules: {
        activity_name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        template_id: [{ required: true, message: '请选择表单', trigger: 'blur' }],
        image_cover: [{ required: true, message: '请选择活动封面', trigger: 'blur' }]
      },
      active: 0,
      selectFormVisible: false,
      selectFormData: [false, { text: '' }],
      // 选择店铺
      storeVisible: false, //选择门店
      selectStoreData: [], //主任务门店列表
      storeIds: -1, //选择门店的id,
      storeNum: '',
      banStoreVisible: false, //选择门店
      selectBanStoreData: [], //主任务门店列表
      storeBanIds: -1, //选择门店的id,
      storeBanNum: '',
      showImgPicker: false,
      coverList: [],
      coverListForm: { pics: [], imageVisible: false, time_type: 3 },
      selectGiftVisible: false,
      selectGiftData: [],
      includeShopList: [],
      excludeShopList: [],
      dateRange: ['', ''],
      subTaskForm: { goodsVisible: false, selectGoodsData: [], time_type: 3, pics: [] },
      salesOrganizationVisible: false,
      showStore: true,
      showGroup: true,
      salesData: {
        selectedStoreIds: [],
        selectedGroupsIds: []
      },
      multipleSelection: [], //多选列表,
      setSalesPerson: {},
      showTips: '',
      stepIndex: '1',
      setTextVisible: false,
      setTextData: []
    }
  },
  mounted () {
    const { id } = this.$route.params
    if (+id) {
      this.ruleForm.activity_id = +id
      this.getActivityInfo(+id)
    }
  },
  methods: {
    // 获取活动详情
    async getActivityInfo (activity_id) {
      const data = await this.$api.formActivity.getFormsActivityInfo({
        activity_id
      })
      if (data) {
        // data.limitRadio = data.join_limit === 0 ? '0' : '1'
        if (data.join_limit) {
          this.ruleForm.join_limit = data.join_limit
        }
        this.ruleForm = data
        this.subTaskForm.selectGoodsData = data.item_list
        this.dateRange = [data.begin_time || '', data.end_time || '']
        this.selectFormData = [false, JSON.parse(data.page_config).content]
        this.ruleForm.item_list = [
          { item_name: data.prize_title, imageUrl: data.prize_pic, item_desc: data.prize_desc }
        ]
        this.ruleForm.text = data.sms_tmpl
        if (data.store_filter === 'include') {
          if (data.store_ids) {
            this.includeShopList = data.store_ids.split(',')
          } else if (data.group_ids) {
            this.includeShopList = data.group_list
          }
        } else {
          if (data.store_ids) {
            this.excludeShopList = data.store_ids.split(',')
          } else if (data.group_ids) {
            this.excludeShopList = data.group_list
          }
        }
        if (data.store_list) {
          this.showTips = 'store'
        }
        if (data.group_ids) {
          this.showTips = 'group'
        }
      }
    },
    submitForm (formName, next) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = this.ruleForm
          const page_config = this.selectFormData[1]
          params.page_config = {
            type: page_config.type,
            content: { ...page_config }
          }
          if (this.dateRange[0] && this.dateRange[1]) {
            params.begin_time = moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss')
            params.end_time = moment(this.dateRange[1]).format('YYYY-MM-DD HH:mm:ss')
          }
          if (!this.ruleForm.join_limit) {
            params.join_limit = 0
          } else {
            params.join_limit = this.ruleForm.join_limit
          }
          params.store_ids = ''
          params.store_list = []
          params.group_ids = ''
          params.group_list = []
          if (this.ruleForm.store_filter === 'include') {
            if (this.showTips === 'store') {
              params.store_ids = this.includeShopList.map((v) => v).join(',')
              params.group_ids = ''
            } else {
              params.group_ids = this.includeShopList.map((v) => v.id).join(',')
              params.store_ids = ''
            }
          } else if (this.ruleForm.store_filter === 'exclude') {
            if (this.showTips === 'store') {
              params.store_ids = this.excludeShopList.map((v) => v).join(',')
              params.group_ids = ''
            } else {
              params.group_ids = this.excludeShopList.map((v) => v.id).join(',')
              params.store_ids = ''
            }
          }
          // if (this.ruleForm.item_list) {
          //   params.item_id = this.ruleForm.item_list.map((v) => v.item_id).join(',')
          // }
          if (this.ruleForm.item_list && this.ruleForm.item_list[0]) {
            params.prize_title = this.ruleForm.item_list[0].item_name
            params.prize_pic = this.ruleForm.item_list[0].imageUrl
            params.prize_desc = this.ruleForm.item_list[0].item_desc
          }
          if (this.ruleForm.text) {
            params.sms_tmpl = this.ruleForm.text
          }
          if (this.subTaskForm) {
            params.item_id = this.subTaskForm.item_id
            params.item_list = this.subTaskForm.selectGoodsData
          }
          if (params.activity_id) {
            const data = await this.$api.formActivity.updateFormsActivity(params)
            if (data) this.saveData('update', next)
          } else {
            const data = await this.$api.formActivity.createFormsActivity(params)
            if (data) {
              this.ruleForm.activity_id = data.activity_id
              this.saveData('create', next)
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    saveData (type, next) {
      let message = type === 'create' ? '创建' : '更新'
      this.$message.success(message + '成功')
      if (next === 1) {
        this.$router.push({
          path: '/drainage/formActivity'
        })
      } else {
        let text = ''
        if (type === 'create') {
          text = '&showStep=1'
        }
        this.$router.push({
          path: '/setting/actionWeappTmp?activity_id=' + this.ruleForm.activity_id + text
        })
      }
      // if() {

      // }
      // this.$confirm('是否增加并配置活动模板页？不配置将直接启用表单页。', '配置活动模板页', {
      //   confirmButtonText: '配置',
      //   cancelButtonText: '不配置',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     // 跳转配置页
      //     this.$router.push({
      //       path: '/setting/actionWeappTmp?activity_id=' + this.ruleForm.activity_id
      //     })
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '取消配置'
      //     })
      //     const { id } = this.$route.params
      //     if (+id) {
      //       this.ruleForm.activity_id = +id
      //       this.getActivityInfo(+id)
      //     } else {
      //       this.$router.push({
      //         path: 'drainage/formActivity'
      //       })
      //     }
      //   })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },

    // 打开表单弹窗
    handleSelectForm () {
      this.selectFormData = [true, this.selectFormData[1]]
      this.selectFormVisible = true
    },

    // 设置表单
    selectFormVisibleChange (value) {
      if (value[0] === false) {
        this.selectFormVisible = false
      }
      if (value[1]) {
        this.selectFormData = value
        this.ruleForm.template_id = value[1].template_id
      }
    },

    // 设置奖品
    selectGiftVisibleChange (value) {
      if (value[0] === false) {
        this.selectGiftVisible = false
      }
      if (value[1]) {
        this.selectGiftData = value
        this.ruleForm.item_list = []
        this.ruleForm.item_list.push(value[1])
      }
    },
    handleEditGift () {
      this.selectGiftData = [true, this.ruleForm.item_list[0]]
      this.selectGiftVisible = true
    },
    // 选择封面
    selectImageData (data) {
      this.ruleForm.image_cover = data
    },

    // 选择奖品
    handleSelectGift () {
      this.selectGiftVisible = true
      this.selectGiftData = [true, this.ruleForm.item_list[0] || {}]
    },

    // 选择门店
    chooseBanStore (selectBandata, storeids) {
      this.ruleForm.shopBanList = selectBandata
      this.selectBanStoreData = selectBandata
      this.storeBanIds = storeids
      //   let storeBns = []
      //   selectdata.forEach((v) => {
      //     storeBns = storeBns.concat(v.store_bn)
      //   })
      //   this.params.store_bn = storeBns
      //   this.storeNum = '已选择' + selectdata.length + '家门店'
      this.banStoreVisible = false
      //   this.haddleSearch()
    },

    //重置门店选择
    clearBanStore () {
      this.selectStoreData = []
      this.storeIds = []
      this.storeNum = ''
      this.params.store_bn = []
      //   this.haddleSearch()
    },
    handleClickChangeImage () {
      this.showImgPicker = true
    },

    // 删除奖品
    handleDeleteGift (index) {
      this.ruleForm.item_list.splice(index, 1)
    },

    // 删除适用门店
    handleDeleteIncludeShop (index) {
      this.includeShopList.splice(index, 1)
    },

    // 删除不适用门店
    handleDeleteExcludeShop (index) {
      this.excludeShopList.splice(index, 1)
    },

    // 打开门店弹窗
    storeVisibleChange (type) {
      if (type === 'include') {
        if (this.showTips === 'store') {
          this.salesData = {
            selectedStoreIds: this.includeShopList,
            selectedGroupsIds: []
          }
        } else {
          this.salesData = {
            selectedStoreIds: [],
            selectedGroupsIds: this.includeShopList
          }
        }
      } else if (type === 'exclude') {
        if (this.showTips === 'store') {
          this.salesData = {
            selectedStoreIds: this.excludeShopList,
            selectedGroupsIds: []
          }
        } else {
          this.salesData = {
            selectedStoreIds: [],
            selectedGroupsIds: this.excludeShopList
          }
        }
      }
      console.log('编辑salesData', this.salesData)
      this.showStore = true
      this.showGroup = true
      this.salesOrganizationVisible = true
    },

    // 选择门店
    chooseStore (selectdata) {
      if (this.ruleForm.store_filter === 'include') {
        this.includeShopList = selectdata
      } else {
        this.excludeShopList = selectdata
      }
      this.storeVisible = false
    },

    onClosePicker () {
      this.showImgPicker = false
    },
    onChangePicker (data) {
      this.showImgPicker = false
      this.coverList.push(data[0])
      this.coverUrl = data[0].image_url
      // if (data.length > 0) {
      //   this.value.icon = data[0].image_url
      // }
      // this.$emit('input', {})
    },

    // 变更日期
    changeDate (e) {
      if (e) {
        this.ruleForm.begin_time = e[0]
        this.dateRange = e
      } else {
        this.ruleForm.begin_time = ''
        this.ruleForm.end_time = ''
        this.dateRange = ['', '']
      }
    },
    back () {
      this.$router.go(-1)
    },
    // 确定绑定销售组织
    saveBindOrganization (selectData, type) {
      if (this.ruleForm.store_filter === 'include') {
        this.includeShopList = selectData
        this.excludeShopList = []
      } else {
        this.excludeShopList = selectData
        this.includeShopList = []
      }
      this.showTips = type
      this.salesOrganizationVisible = false
    },
    handleText () {
      this.setTextData = [true, this.ruleForm.text]
      this.setTextVisible = true
    },
    setTextVisibleChange (value) {
      if (value[0] === false) {
        this.setTextVisible = false
      }
      if (value[1]) {
        this.ruleForm.text = value[1]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mb10 {
  margin-bottom: 10px;
}
.tips {
  margin-left: 10px;
  color: rgb(136, 136, 136);
}
.pics {
  display: flex;
  flex: 1;
  flex-direction: row;
}
.image-cover {
  display: inline-block;
}
.radio-tips {
  margin: 0 30px 0 -15px;
  display: inline-block;
  .el-icon-question {
    font-size: 16px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.set {
  margin-top: 4px;
  margin-left: 70px;
}
.w45 {
  width: 45%;
}
.ml20 {
  margin-left: 20px;
}
</style>
